module.exports = __webpack_public_path__ + "static/frame-pay-faster-9a76402344a49039461e70741fb80db4.jpg";